import React from "react";
import { FILTERS, countBy } from "./knowledge-filters";

// `keys` lets a page pick which filters it offers (chapter page says "Saved").
const FilterPills = ({ articles, value, onChange, keys = ["all", "new", "unread", "saved"], labels = {} }) => (
  <div className="flex items-center gap-2 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden -mx-1 px-1">
    {keys.map((key) => {
      const active = value === key;
      return (
        <button
          key={key}
          type="button"
          onClick={() => onChange(key)}
          className={`flex-shrink-0 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md border text-xs font-semibold ${
            active
              ? "bg-primary_tint text-primary border-primary/40"
              : "bg-surface text-text_secondary border-border"
          }`}
        >
          {labels[key] || FILTERS[key].label}
          <span className={active ? "text-primary" : "text-text_muted"}>{countBy(articles, key)}</span>
        </button>
      );
    })}
  </div>
);

export default FilterPills;
